import {
  PRIVILEGED_TRAIL_REQ,
  PRIVILEGED_TRAIL_SET,
  PRIVILEGED_TRAIL_REQ_SUCCESS,
  PRIVILEGED_TRAIL_REQ_ERROR,
  PRIVILEGED_TRAIL_RANGE_REQ,
  PRIVILEGED_TRAIL_RANGE_REQ_SUCCESS,
  PRIVILEGED_TRAIL_RANGE_REQ_ERROR,
  PRIVILEGED_ACTIVITIES_TRAILS_PREFERENCES_VIEW_REQ,
  SAVE_PRIVILEGED_ACTIVITIES_TRAILS_VIEW_PREFERENCES,
  PRIV_VIEW_ACTIVITIES_PREFERENCES_REQ,
  SAVE_PRIV_VIEW_ACTIVITIES_PREFERENCES
} from './trailsinfo.type'

import ApiRest from '@/api/api-rest'
import IQCollection from '@/resources/collections/IQCollection'
import PrivilegedTrail from '@/resources/models/PrivilegedTrail'
import { OrderByEnum } from '@/constants/orderby.constants'
import { getDateRangeChoice, getTimeSinceMidnight } from '@/utilities/datetime.helper'
import { privilegedTrailsMetaInfo } from '@/column-header/trail/privileged-trails-meta'

const state = {
  privilegedTrailReqStatus: '',
  privilegedTrailRecords: {},
  privilegedActivitiesTrailsPreferences: [],
  privActivitiesPreferences: []
}

const getters = {
  privilegedTrailReqStatus: state => state.privilegedTrailReqStatus,
  privilegedTrailRecords: state => state.privilegedTrailRecords,
  privilegedActivitiesTrailsPreferences: state => state.privilegedActivitiesTrailsPreferences,
  privActivitiesPreferences: state => state.privActivitiesPreferences
}

// Best Practice - updates state
const mutations = {
  [PRIVILEGED_TRAIL_REQ]: state => {
    state.privilegedTrailReqStatus = 'loading'
  },
  [PRIVILEGED_TRAIL_SET]: (state, data) => {
    state.privilegedTrailRecords = data
  },
  [PRIVILEGED_TRAIL_REQ_SUCCESS]: (state, data) => {
    state.privilegedTrailReqStatus = 'saved'
  },
  [PRIVILEGED_TRAIL_REQ_ERROR]: (state, errMsg) => {
    state.privilegedTrailReqStatus = 'error'
  },
  [PRIVILEGED_TRAIL_RANGE_REQ]: state => {
    state.privilegedTrailReqStatus = 'loading'
  },
  [PRIVILEGED_TRAIL_RANGE_REQ_SUCCESS]: (state, data) => {
    state.privilegedTrailReqStatus = 'saved'
  },
  [PRIVILEGED_TRAIL_RANGE_REQ_ERROR]: (state, errMsg) => {
    state.privilegedTrailReqStatus = 'error'
  },
  [PRIVILEGED_ACTIVITIES_TRAILS_PREFERENCES_VIEW_REQ]: (state, data) => {
    state.privilegedActivitiesTrailsPreferences = data
  },
  [PRIV_VIEW_ACTIVITIES_PREFERENCES_REQ]: (state, data) => {
    state.privActivitiesPreferences = data
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [PRIVILEGED_ACTIVITIES_TRAILS_PREFERENCES_VIEW_REQ] (context, uid) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('preferences')
        .then(({ data }) => {
          let currUserPrivilegedActivitiesPrefs = data.find(pref => {
            return pref.tbl_id === 12 && pref.user_id === uid
          })
          context.commit(PRIVILEGED_ACTIVITIES_TRAILS_PREFERENCES_VIEW_REQ, currUserPrivilegedActivitiesPrefs.prefered_cols)
          resolve(data)
        })
    })
  },
  [SAVE_PRIVILEGED_ACTIVITIES_TRAILS_VIEW_PREFERENCES] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('preferences', {
          userId: payload.userId,
          tblId: payload.tblId,
          preferedCols: payload.preferedCols
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [PRIV_VIEW_ACTIVITIES_PREFERENCES_REQ] (context, uid) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('preferences')
        .then(({ data }) => {
          let currUserPrivActivitiesPrefs = data.find(pref => {
            return pref.tbl_id === 13 && pref.user_id === uid
          })
          context.commit(PRIV_VIEW_ACTIVITIES_PREFERENCES_REQ, currUserPrivActivitiesPrefs.prefered_cols)
          resolve(data)
        })
    })
  },
  [SAVE_PRIV_VIEW_ACTIVITIES_PREFERENCES] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('preferences', {
          userId: payload.userId,
          tblId: payload.tblId,
          preferedCols: payload.preferedCols
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [PRIVILEGED_TRAIL_REQ] (context, { state, dateRangeSel } = {}) {
    let lastXHours = ''
    if (dateRangeSel) {
      lastXHours = getDateRangeChoice(dateRangeSel)
    } else {
      lastXHours = getDateRangeChoice(context.rootState.daterangePref.dashboardProgressionDateRangeUserSetting)
    }

    let trailsUrl = `/trails/privileged/${lastXHours.hours}`

    if (lastXHours.value === 'SINCE_MIDNIGHT') {
      let timeSinceMidnight = getTimeSinceMidnight()
      trailsUrl = `/trails/privileged/range/${encodeURIComponent(timeSinceMidnight.starttime)}/${encodeURIComponent(
        timeSinceMidnight.endtime
      )}`
    }

    return new Promise((resolve, reject) => {
      context.commit(PRIVILEGED_TRAIL_REQ)
      ApiRest()
        .get(trailsUrl)
        // .get('static/json/privileged.json')
        .then(({ data }) => {
          data = data.map(trail => {
            let attackTrail = new PrivilegedTrail('trailIdHash', trail)
            attackTrail.configureKillChainFormat()
            return attackTrail
          })

          data = new IQCollection(
            data,
            { attributes: privilegedTrailsMetaInfo.meta.columns },
            { defaultSort: 'numberOfDetections', sortOrder: OrderByEnum.DESC }
          )
          context.commit(PRIVILEGED_TRAIL_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(PRIVILEGED_TRAIL_REQ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [PRIVILEGED_TRAIL_REQ_SUCCESS] (context) {
    context.commit(PRIVILEGED_TRAIL_REQ_SUCCESS)
  },
  [PRIVILEGED_TRAIL_RANGE_REQ] (context) {
    const startTimeIso = new Date(new Date().setHours(0, 0, 0, 0)).toISOString()
    const endTimeIso = new Date(Date.now()).toISOString()

    return new Promise((resolve, reject) => {
      context.commit(PRIVILEGED_TRAIL_RANGE_REQ)
      ApiRest()
        .get(`/trails/privileged/range/${encodeURIComponent(startTimeIso)}/${encodeURIComponent(endTimeIso)}`)
        .then(({ data }) => {
          context.commit(PRIVILEGED_TRAIL_RANGE_REQ_SUCCESS, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(PRIVILEGED_TRAIL_RANGE_REQ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/trails/privilegedtrail.module.js